<template>
  <v-dialog max-width="600" v-model="dialog" @keydown.enter.prevent="onenter">
    <v-card>
      <v-card-title>
        <span class="headline">Ancient Treasure Bundle ({{ this.rules.name }})</span>
      </v-card-title>
      <v-card-text>
        <v-row dense class="mb-4 pt-4">
          <v-col cols="12" md="12" sm="12">
            <v-text-field disabled label="UID:" v-model.trim="model.uid" hide-details outlined dense/>
          </v-col>
          <!--                    <v-col cols="66" md="4" sm="4">-->
          <!--                        <r-smart-offer-bundle-achievement-type :model.sync="model.type" label="Type"/>-->
          <!--                    </v-col>-->
          <!--                    <v-col cols="12" md="4" sm="4">-->
          <v-text-field
            label="Name"
            v-model.trim="model.name"
            class="mr-2"
            v-ascii-only
          />
          <!--                    </v-col>-->
          <!--                    <v-col cols="12" md="4" sm="4">-->
          <v-text-field
            label="Key"
            v-model.trim="model.key"
            v-ascii-only
          />
          <!--                    </v-col>-->
        </v-row>
        <v-expansion-panels>
          <r-panel title="Settings">
            <v-row dense>
              <v-col cols="12" sm="4" md="4">
                <v-text-field v-model.number="model.iconBadgeExpires" label="Icon Badge Expires" hide-details/>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-text-field v-model.number="model.iconTooltipReset" label="Icon Tooltip Reset" hide-details/>
              </v-col>
            </v-row>
          </r-panel>
          <r-guard-panel :model.sync="model.guard" title="Guard Config"/>
          <r-guard-money-panel :model.sync="model.guardMoney" title="Guard Money"/>
        </v-expansion-panels>
        <v-row dense class="mt-3">
          <v-col cols="12" sm="5" md="5">
            <r-currency-kind-dropdown :model.sync="model.currency_chest" label="Chest Currency" class="mr-2"/>
          </v-col>
          <v-col cols="12" sm="5" md="5">
            <r-currency-kind-dropdown :model.sync="model.currency_progress" label="Progress Currency"/>
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <v-text-field v-model.number="model.freeKeys" label="Free keys" hide-details/>
          </v-col>
        </v-row>
        <v-row dense class="mt-3">
          <v-col cols="12" sm="6" md="6">
            <r-product-dropdown :model.sync="model.product" :groups="groups_product" label="Premium Product"/>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <r-item-dropdown :model.sync="model.statue_item" label="Statue Item"/>
          </v-col>
        </v-row>
        <v-row dense class="pt-1">
          <v-card-title class="blue--text">Rewards Tracks</v-card-title>
          <v-expansion-panels>
            <r-reward-bunch-panel :model.sync="model.rewards" title="Default" label="Reward" :points="true"/>
            <r-reward-bunch-panel :model.sync="model.rewards_premium" title="Premium" label="Reward" :points="true"/>
          </v-expansion-panels>
          <v-card-title class="orange--text">Chests Tracks</v-card-title>
          <v-expansion-panels>
            <r-reward-bunch-panel :model.sync="model.chests" title="Default" label="Chests" :points="true"/>
            <r-reward-bunch-panel :model.sync="model.chests_optional" title="Optional" label="Chest Optional" :points="true"/>
          </v-expansion-panels>
          <v-card-title class="green--text">Exchange</v-card-title>
          <v-expansion-panels>
            <r-ancient-treasure-exchange-config :model.sync="model.exchangeConfig"/>
          </v-expansion-panels>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {ProductGroupKind} from "@/modules/redactor/models/product/ProductGroupKind";
import {SmartOfferBundleAncientTreasure} from "@/modules/redactor/models/smart-offer/bundle-ancient-treasure/SmartOfferBundleAncientTreasure";

import RGuardPanel from "@/modules/redactor/views/guard/r-guard-panel.vue";
import RGuardMoneyPanel from "@/modules/redactor/views/guard/r-guard-money-panel.vue";
import RCurrencyKindDropdown from "@/modules/redactor/views/currency-kind/r-currency-kind-dropdown.vue";
import RProductDropdown from "@/modules/redactor/views/product/r-product-dropdown.vue";
import RRewardBunchPanel from "@/modules/redactor/views/reward/r-reward-bunch-panel.vue";
import RItemDropdown from "@/modules/redactor/views/item/r-item-dropdown.vue";
import RAncientTreasureExchangeConfig from "@/modules/redactor/views/smart-offer/bundle-ancient-treasure/r-ancient-treasure-exchange-config.vue";
import RPanel from "@/modules/redactor/views/utils/r-panel.vue";


export default {
  name: "r-smart-offer-bundle-ancient-treasure",
  components: {
    RPanel,
    RAncientTreasureExchangeConfig,
    RItemDropdown,
    RRewardBunchPanel,
    RProductDropdown,
    RCurrencyKindDropdown,
    RGuardMoneyPanel,
    RGuardPanel
  },
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    tab: null,
    model: new SmartOfferBundleAncientTreasure(),
    rules: ViewRules.READONLY,
  }),
  computed: {
    groups_product() {
      return [ProductGroupKind.SMART_OFFERS]
    },
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.tab = null;
      this.rules = rules;
      this.model = model || new SmartOfferBundleAncientTreasure();
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    },
    onenter() {
      this.save();
    }
  }
}
</script>

<style lang="css" scoped>
.fill-width {
  width: 100%;
}
</style>